import { NavLink } from 'react-router-dom';
import { CHeader, CHeaderToggler } from '@coreui/react';
import { useSidebar } from 'contexts/AppContext';
import theme from 'config/theme';

const { zIndexNavbar } = theme;

const Header = () => {
  const { toggleSidebar, toggleSidebarMobile } = useSidebar();

  // Bug: below the lg breakpoint the open sidebar starts under the header (both have z-index 10), which covers its
  // first item (Projekte); it was so with CoreUI 3 too.
  return (
    // CoreUI 5's header is a div; the role keeps the landmark of the <header> CoreUI 3 rendered.
    <CHeader position="sticky" role="banner" style={{ zIndex: zIndexNavbar }}>
      <CHeaderToggler className="ms-md-3 d-lg-none" onClick={toggleSidebarMobile} />
      <CHeaderToggler className="ms-3 d-none d-lg-block" onClick={toggleSidebar} />
      <NavLink className="header-brand mx-auto d-lg-none" to="/" />
    </CHeader>
  );
};

export default Header;
